import { render, staticRenderFns } from "./AppAsideMenu.vue?vue&type=template&id=c4625b24&scoped=true&"
import script from "./AppAsideMenu.vue?vue&type=script&lang=js&"
export * from "./AppAsideMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppAsideMenu.vue?vue&type=style&index=0&id=c4625b24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4625b24",
  null
  
)

export default component.exports